import React from "react";
import { Box, Stack, Typography, Tooltip, IconButton, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import { buttonStyles } from "./featureConfig";
import MyDatePicker from "./DatePicker";

const FeatureHeader = ({ onRefresh, onOpenSubmit, startDate, endDate, setStartDate, setEndDate, handleApplyRange }) => (
  <Stack
    direction={{ xs: "column", sm: "row" }}
    alignItems={{ xs: "flex-start", sm: "center" }}
    justifyContent="space-between"
    spacing={2}
    mb={3}
  >
    <Box>
      <Typography variant="h4" sx={{ fontSize: "24px" }} fontWeight={700} color="#1f2937">
        Feature Requests
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Share ideas, vote on priorities, and follow delivery progress.
      </Typography>
    </Box>

    <MyDatePicker
      handleApplyRange={handleApplyRange}
      startDate={startDate}
      endDate={endDate}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
    />

    {/* <Stack direction="row" spacing={1}>
      <Tooltip title="Refresh">
        <IconButton onClick={onRefresh}>
          <RefreshIcon />
        </IconButton>
      </Tooltip>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={onOpenSubmit}
        sx={buttonStyles.contained}
      >
        Submit Request
      </Button>
    </Stack> */}
  </Stack>
);

export default FeatureHeader;